import request from '@/service/index'
import postJson from "@/service/postJson"
/**
 * 获取分类
 */
export const qryAccountStatistic = (params) => {
    return request({
        url: 'shop/shopAccount/qryAccountStatistic',
        params,
        method: 'get'
    })
}
//查询商家收入统计
export const qryShopIncome = (params) => {
    return request({
        url: 'shop/shopAccount/qryShopIncomeStatistic',
        params,
        method: 'get'
    })
}
//按查询日期查询商家收入
export const qryShopIncomeByDate = (params) => {
    return request({
        url: 'shop/shopAccountLog/qryShopIncomeByDate',
        params,
        method: 'get'
    })
}

//提现申请
export const withdrawApply = (data) => {
    return postJson({
        url: 'shop/shopAccountWithdraw/apply',
        method: 'post',
        data,
        headers:{'Content-Type': 'application/json' }
    })
}

//查询商家账户信息
export const getShopAccountInfo = (params) => {
    return request({
        url: 'shop/shopAccount/qryAccountInfo',
        method: 'get',
        params,
    })
}



// WEBPACK FOOTER //
// ./src/api/account.js